import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	selector: "app-books-for-instructor",
	templateUrl: "./books-for-instructor.component.html",
	styleUrls: ["./books-for-instructor.component.css"],
})
export class BooksForInstructorComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private reportService: ReportService, private dialogService: DialogService) {}

	report = {
		SchoolID: 0,
		Teacher_PersonID: 0,
		ReturnedID: "ALL",
	};

	lstInstructor: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstReturned = [
		{
			ID: "ALL",
			Desc: "All",
		},
		{
			ID: "YES",
			Desc: "Yes",
		},
		{
			ID: "NO",
			Desc: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 58;
	subscription: any;

	ngOnInit() {
		// this.AttendanceStatusList();
		// this.EntryTypeList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		this.InstructorList();
	}

	private InstructorList() {
		this.report.Teacher_PersonID = 0;
		var result = this.reportService.InstructorGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.lstInstructor = response;

				this.report.Teacher_PersonID = this.lstInstructor[0].Teacher_PersonID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		// @RETURNED
		// @TEACHER_PERSONID

		var reportID = 58;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.report.ReturnedID + "|RETURNED";
		strParam += "," + this.report.Teacher_PersonID + "|TEACHER_PERSONID";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
